import UserPrivateComponent from "@/components/PrivacyComponent/UserPrivateComponent";
import {
  useGetCampaignCodeQuery,
  useUpdateCampaignCodeMutation,
} from "@/redux/rtk/features/campaignCode/campaignCodeApi";

import { Button, Form, Input } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function UpdateCampaignCode({ data, onClose }) {
  const { t } = useTranslation();
  const { id } = data;
  const [form] = Form.useForm();

  const { data: campaignCode, isLoading: campaignCodeLoading } =
    useGetCampaignCodeQuery({ id });

  const [updateCampaignCode, { isLoading }] = useUpdateCampaignCodeMutation();

  const onFinish = async (values) => {
    const formData = {
      name: values.name,
    };

    const resp = await updateCampaignCode({ id, values: formData });
    if (resp.data) {
      form.resetFields();
      onClose();
    }
  };

  useEffect(() => {
    if (campaignCode) {
      form.setFieldsValue({
        ...campaignCode,
      });
    }
  }, [form, campaignCode]);

  return (
    <div className="flex justify-center mt-5">
      <UserPrivateComponent permission="update-campaignCode" type="update" comment={t("common.permissionError")}>
        <Form
          className="w-full"
          onFinish={onFinish}
          colon={false}
          layout="vertical"
          form={form}>
          <div className="w-full px-10">
            <Form.Item
              label={t("campaignCode.name") || "Campaign Code Name"}
              name="name"
              rules={[
                { required: true, message: t("campaignCode.nameRequired") || "Please enter campaign code name" },
              ]}>
              <Input placeholder={t("campaignCode.name") || "Campaign Code Name"} />
            </Form.Item>
          </div>

          <Form.Item label="" className="px-10">
            <div className="flex items-center gap-2">
              <Button
                size={"large"}
                htmlType="submit"
                type="primary"
                loading={isLoading}>
                {t("common.save")}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </UserPrivateComponent>
    </div>
  );
}
